import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_168_1292)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.0004 7.00021C15.3897 7.38949 15.39 8.02052 15.0012 8.41021L11.125 12.2948L15.0012 16.1794C15.39 16.5691 15.3897 17.2002 15.0004 17.5894C14.6108 17.979 13.9792 17.979 13.5896 17.5894L9.00212 13.0019C8.6116 12.6114 8.6116 11.9782 9.00212 11.5877L13.5896 7.00021C13.9792 6.61064 14.6108 6.61064 15.0004 7.00021Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_168_1292",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgChevronLeft;
